App.directive('formSpouseTpl', ['$window', 'Config', '$filter', 'statesService', '$q', '$stateParams',
    function ($window, Config, $filter, statesService, $q, $stateParams) {
        return {
            restrict: 'AEC',
            scope: {
                form: '=',
                model: '=',
                prefix: '@',
                withSibling: '=',
                showTypeSwitch: '=?',
                zoch: '=',
                addressToApply: '<?'
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/form-spouse-tpl.html',
            controller: ['$scope', function ($scope) {

                var self = this;

                $scope.partnerSelected = $stateParams.isPartner ? $stateParams.isPartner : false;
                $scope.spouseDisabled = true;
                (function () {
                    if (!$scope.partnerSelected) {
                        $scope.spouseDisabled = false;
                    }
                })();

                $scope.maxDate = new Date();

                var getResults = function (query) {
                    var deferred = $q.defer();

                    statesService.dataCityLists({
                        name: query
                    }).then(function (data) {
                        deferred.resolve(data.data);
                    });

                    return deferred.promise;
                };

                // ##### LOCALIZATION FILTER ##### //
                $scope.querySearchLocalization = function (query) {
                    if (!query) {
                        return;
                    }

                    return getResults(query).then(function (results) {
                        return results;
                    });
                };

                if (!angular.isDefined($scope.model.partner)
                    || !$scope.model.partner) {
                    $scope.model['partner'] = {
                        citizenshipType: 'POLISH'
                    };
                }

                if (!angular.isDefined($scope.model.assured)
                    || !$scope.model.assured) {
                    $scope.model['assured'] = [{
                        type: 'PERSON',
                        country: 'POLISH',
                        personBirthdate: null,
                        sameAddress: true
                    }];
                }

                $scope.addAssured = function () {
                    if ($scope.model['assured'].length < 4) {
                        $scope.model['assured'].push({
                            type: 'PERSON',
                            country: 'POLISH',
                            personBirthdate: null,
                            sameAddress: true
                        });
                    }
                };

                $scope.deleteAssured = function (obj) {
                    $scope.model['assured'].splice(obj, 1);
                };

                self.$onInit = function () {
                    $scope.sameAddressAsUser = !!$scope.addressToApply;
                };

                self.$onChanges = function (changes) {
                    console.log('[formSpouseTpl] [$onChanges]', changes);
                    if (changes && changes.addressToApply) {
                        $scope.sameAddressAsUser = !!$scope.addressToApply;
                    }
                };


                $scope.differentDateThanBirthdate = function (value) {
                    let birthDate;
                    if ($scope.model['person'].citizenshipType === 'POLISH') {
                        birthDate = $filter('getDateFromIdentifier')($scope.model['person'].identifier)
                    } else {
                        birthDate = $scope.model['person'].birthdate;
                    }
                    return !moment(birthDate).isSame(value, 'day');
                };

                $scope.differentDateThanMainUserBirthdate = function (value) {
                    if ($stateParams.person) {
                        return !moment($stateParams.person.birthdate).isSame(value, 'day');
                    } else {
                        return true;
                    }
                };

                $scope.additional = {
                    notExistEmail: false,
                    notExistPhone: false
                }

                $scope.$watch('model.person.citizenshipType', function (newVal, oldVal) {
                    if (newVal && newVal !== oldVal) {
                        $scope.form[$scope.prefix + 'marriage_date'].$setTouched()
                        $scope.form[$scope.prefix + 'marriage_date'].$validate();
                    }
                }, true);

                $scope.$watch('model.person.identifier', function (newVal, oldVal) {
                    if (newVal && newVal !== oldVal) {
                        $scope.form[$scope.prefix + 'marriage_date'].$setTouched()
                        $scope.form[$scope.prefix + 'marriage_date'].$validate();
                    }
                }, true);

                $scope.$watch('model.person.birthdate', function (newVal, oldVal) {
                    if (newVal && newVal !== oldVal) {
                            $scope.form[$scope.prefix + 'marriage_date'].$setTouched()
                        $scope.form[$scope.prefix + 'marriage_date'].$validate();
                    }
                }, true);

                $scope.$watch('additional.notExistEmail', function (oldVal, newVal) {
                    console.log(oldVal, newVal);
                    if (oldVal !== newVal) {
                        if ($scope.additional.notExistEmail) {
                            $scope.model['person'].email = '';
                        }
                    }
                }, true);

                $scope.$watch('additional.notExistPhone', function (oldVal, newVal) {
                    console.log(oldVal, newVal);
                    if (oldVal !== newVal) {
                        if ($scope.additional.notExistPhone) {
                            $scope.model['person'].phone = '';
                        }
                    }
                }, true);


            }]
        }
    }]);